<template>
    <section id="about" class="outer">
        <div class="inner">
            <header class="title">{{ title }}</header>
            <p>{{ intro }}</p>

            <header class="subtitle">{{ subtitle }}</header>
            <ul>
                <li v-for="use in uses">{{ use }}</li>
            </ul>
            <p>{{ more }}</p>
        </div>
    </section>
</template>

<script>
    export default {
        data () {
            return {
                title: 'About Tito Control',
                intro: 'Tito Control can turn your iPhone, iPad and Watch into a Mac\'s input device, easily connected through USB or Bluetooth. It also supports custom key mapping, mechanical keyboard sound and other functions.',
                subtitle: 'You can:',
                uses: [
                    'Control Mac computer with your iPhone or Watch when presentation.',
                    'Make your iPad as a secondary keyboard.',
                    'Use your iOS device as a remote control while watching videos.'
                ],
                more: 'More uses await your imagination.'
            }
        }
    }
</script>

<style>
    #about {
        padding-top: 40px;
        padding-bottom: 40px;
        background-color: #f8f8f8;
    }

    #about ul {
        display: inline-block;
        text-align: left;
        list-style-type: circle;
    }
</style>



// WEBPACK FOOTER //
// src/components/About.vue